import { combineReducers } from 'redux';
import backyardCompanyReducer from './company';

const backyardReducer = combineReducers({
  company: backyardCompanyReducer,
});

export default backyardReducer;
